<script>
    import { auth, trackEvent } from "@/services/firebase";
    import { goTo } from "@/utils/router";
    import appStore from "@/utils/store";
    import { Preferences } from "@capacitor/preferences";
    import { SocialLogin } from "@capgo/capacitor-social-login";

    const searchParams = new URLSearchParams(window.location.search);
    const cause = searchParams.get("cause");
    console.log("Logout cause:", cause);
    appStore.delete("user");
    appStore.reset();
    Preferences.clear();

    try {
        SocialLogin.logout({
            provider: "google",
        });
        console.log("--> SocialLogin.logout called");
        auth.signOut().then(() => {
            console.log("User logged out from Firebase");
        });
    } catch (error) {
        console.error("Error during Google logout:", error);
    }

    // Ir al login
    goTo("/login", { replace: true });
    trackEvent("logout");
</script>
